<template>
  <div class="mm-page-main"  v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">門市管理</div>
      <el-link @click="gotoruter('/AddStore')" type="primary"><i class="el-icon-circle-plus"></i>添加門市</el-link>
    </div>
    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.short}} {{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>門店系統-員工列表</h3>
          </div>
          <div>
            <el-button @click="editstore()" class="text-white">編輯門市</el-button>
            <el-button @click="openchooseuser()" type="primary" class="text-white">導入員工</el-button>
            <el-dialog @closed="closechooseuser" title="導入員工" :visible.sync="chooseuser" width="80%" :append-to-body="true">
              <component @closedialog="closedialog" :store_id="store_id" :is="chooseuser_component"></component>
            </el-dialog>
          </div>
        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="userdata" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="username" label="用戶名" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">用戶名</div>
                <div>{{scope.row.username}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">姓名</div>
                <div>{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="郵箱" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">郵箱</div>
                <div>{{scope.row.email}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="電話" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">電話</div>
                <div>{{scope.row.phone}}</div>
              </template>
            </el-table-column>
            <el-table-column sortable prop="sex" label="性別" align="center">
              <template slot-scope="scope">
                <div class="phonecel">性別</div>
                <div v-if="scope.row.sex == 0">男</div>
                <div v-else>女</div>
              </template>

            </el-table-column>
            <!-- <el-table-column sortable prop="age" label="年齡" align="center">
              <template slot-scope="scope">
                <div class="phonecel">年齡</div>
                <div>{{scope.row.age}}</div>
              </template>
            </el-table-column> -->
            <el-table-column sortable prop="status" label="狀態" align="center">
              <template slot-scope="scope">
                <div class="phonecel">狀態</div>
                <div v-if="scope.row.status == 0">啟用</div>
                <div v-else>禁用</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <el-button @click="getout(scope.row.user_id)" size="mini">剔除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>牌價系統-員工列表</h3>
          </div>
          <div>
            <el-button @click="openchooseuser2()" type="primary" class="text-white">導入員工</el-button>
            <el-dialog @closed="closechooseuser2" title="導入員工" :visible.sync="chooseuser2" width="80%" :append-to-body="true">
              <component @closedialog="closedialog2" :store_id="store_id" :is="chooseuser_component2"></component>
            </el-dialog>
          </div>
        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="userdata2" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="username" label="用戶名" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">用戶名</div>
                <div>{{scope.row.username}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">姓名</div>
                <div>{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="郵箱" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">郵箱</div>
                <div>{{scope.row.email}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="電話" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">電話</div>
                <div>{{scope.row.phone}}</div>
              </template>
            </el-table-column>
            <el-table-column sortable prop="sex" label="性別" align="center">
              <template slot-scope="scope">
                <div class="phonecel">性別</div>
                <div v-if="scope.row.sex == 0">男</div>
                <div v-else>女</div>
              </template>

            </el-table-column>
            <!-- <el-table-column sortable prop="age" label="年齡" align="center">
              <template slot-scope="scope">
                <div class="phonecel">年齡</div>
                <div>{{scope.row.age}}</div>
              </template>
            </el-table-column> -->
            <el-table-column sortable prop="status" label="狀態" align="center">
              <template slot-scope="scope">
                <div class="phonecel">狀態</div>
                <div v-if="scope.row.status == 0">啟用</div>
                <div v-else>禁用</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <el-button @click="getout2(scope.row.user_id)" size="mini">剔除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import chooseuser from "./components/chooseuser.vue";
import chooseuser2 from "./components/chooseuser2.vue";
export default {
  components: {
    chooseuser,
    chooseuser2
  },
  data () {
    return {
      loading: true,
      chooseuser: false,
      chooseuser2: false,
      transform: '',
      transformnum: 0,
      store_id: 0,
      mso_id:0,
      stores: [],
      userdata: [],
      userdata2: [],
      chooseuser_component: '',
      chooseuser_component2: '',
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    editstore () {

      this.$router.push({
        name: '/EditStore',
        path: '/EditStore',
        params: {
          id: this.store_id
        }
      })
    },
    closedialog () {
      this.chooseuser = false;
      this.chooseuser_component = '';
      this.sectoruser();
    },
    // 牌價系統
    closedialog2 () {
      this.chooseuser2 = false;
      this.chooseuser_component2 = '';
      this.sectoruser2();
    },
    closechooseuser () {
      this.chooseuser = false;
      this.chooseuser_component = '';
      this.sectoruser();
    },
    closechooseuser2 () {
      this.chooseuser2 = false;
      this.chooseuser_component2 = '';
      this.sectoruser2();
    },
    openchooseuser () {
      this.chooseuser = true;
      this.chooseuser_component = chooseuser;
    },
    openchooseuser2 () {
      this.chooseuser2 = true;
      this.chooseuser_component2 = chooseuser2;
    },
    sectoruser () {
      this.post('/api/store/sectoruser', {
        mso_id:this.mso_id,
        store_id: this.store_id
      }).then((res) => {
        this.userdata = res;
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    sectoruser2 () {
      this.userdata2 = [];
      this.post('/api/store/sectoruser2', {
        store_id: this.store_id
      }).then((res) => {
        this.userdata2 = res;
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    getout (user_id) {
      let store_id = this.store_id;
      this.post('/api/store/getout', {
        store_id: store_id,
        user_id: user_id
      }).then((res) => {

        this.sectoruser();

      }).catch((err) => {

        console.log(err)
      })
    },
    // 剔除牌價系統員工
    getout2 (user_id) {
      let store_id = this.store_id;
      this.post('/api/store/getout2', {
        store_id: store_id,
        user_id: user_id
      }).then((res) => {

        this.sectoruser2();

      }).catch((err) => {

        console.log(err)
      })
    },
    changeoffice (office_id) {
      this.office_id = office_id;
      this.getstore();
    },
    changestore (store_id) {
      this.store_id = store_id;
      this.sectoruser();
      this.sectoruser2();
    },

    gotoruter (name) {
      this.$router.push(name)
    },
    getstore () {

      this.post('/api/store/index', {

      }).then((res) => {

        if (res.length > 0) {
          this.store_id = res[0].id;
        }
        this.stores = res;


      }).catch((err) => {

        console.log(err)
      }).then(() => {
        this.sectoruser();
        this.sectoruser2();
      })


    }

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.getstore();
  },


}
</script>

<style scoped>
</style>
